<template>
  <div>
    <typeahead :data="searchResults"
               :serializer="(r) => r.display"
               :show-all-results="true"
               :max-matches="30"
               v-model="searchTerm"
               :minMatchingChars="1"
               @hit="hit($event)"
               placeholder="Suche ...">
      <template slot="suggestion" slot-scope="{ data, htmlText }">
        <div>
          <span v-html="htmlText"></span>
          <i class="ml-auto fab fa-github-square fa-2x"></i>
        </div>
      </template>
    </typeahead>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchTerm: '',
      searchResults: []
    }
  },
  methods: {
    hit(event){
      this.$emit('select', event)
      this.searchTerm = ''
    }
  },
  watch: {
    searchTerm() {
      this.$api.post('/search', {
        term: this.searchTerm
      }).then(response => {
        this.searchResults = response.data.filter(r => r.type === 'customer')
      }).catch(error => this.handleError(error))
    }
  }
}
</script>
